import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c0a5cdac&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=c0a5cdac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a5cdac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0a5cdac')) {
      api.createRecord('c0a5cdac', component.options)
    } else {
      api.reload('c0a5cdac', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=c0a5cdac&scoped=true&", function () {
      api.rerender('c0a5cdac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/message/list.vue"
export default component.exports